import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { clear } from "@testing-library/user-event/dist/clear";

const AddConference = () => {
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    //const [isChecked, setChecked] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const [isCouponClam, setCouponClam] = useState(false);
    
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid')
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedEndDate, setSelectedEndDate] = useState('');
    const [conferenceCategory, setConferenceCategory] = useState('');
    const [conferenceCategoryData, setConferenceCategoryData] = useState([]);
    const [addConference, setAddConference] = useState({
      event_name: eventName,
      w_workshop_name: "",
      conference_day: "",
      w_workshop_amount: "",
      w_workshop_seats: "",
      w_workshop_discount_amount:"",
      conference_start_time: "",
      conference_end_time: "",
      conference_date: "",
      conference_end_date: "",
      conferenceCategory: "",
      isChecked: false,
      isCouponClam: false,
      c_conference_aed_price: "",
      c_conference_doller_price: "",

      error_list: [],
    });
    const handleCheckboxChange = () => {
      setChecked(!isChecked);
    };
   const  handleCheckboxCouponClam = (e) => {
      setCouponClam(!isCouponClam);
    }
    useEffect(() => {
      axios.get(`api/conference-category-index?id=${eventid}`).then(res => {
        if (res.status == 200) {
          const cCategoryData = res.data.conferenceCategories;
          setConferenceCategoryData(cCategoryData);
        }
        else {
          swal('Error', "Check API Something Wrong", 'error');
  
        }
  
  
      });
  
    }, []);
  
  
    // const handleCheckboxChange = () => {
    //     setChecked(!isChecked);
    // };
  
    const handleInput = (e) => {
      e.persist();
      setAddConference({ ...addConference, [e.target.name]: e.target.value });
    }
  
  
  
    const handleStartTime = (event) => {
      setStartTime(event.target.value);
    };
  
    const handleEndTime = (event) => {
      setEndTime(event.target.value);
    };
  
  
  
    const handleDateChange = (event) => {
      setSelectedDate(event.target.value);
    };
    
const handleEndDateChange = (event) => {
      setSelectedEndDate(event.target.value); 
}
    
  
    const handleConferenceCategory = (e) => {
      setConferenceCategory(e.target.value);
    }
  
    const submitConference = (e) => {
  
      e.preventDefault();
  
      const data = {
        eventid,
        event_name: addConference.event_name,
        conference_name: addConference.w_workshop_name,
        conference_day: addConference.conference_day,
        conference_amount: addConference.w_workshop_amount,
        conference_discount_amount: addConference.w_workshop_discount_amount,
        conference_no_of_seats: addConference.w_workshop_seats,
        conference_start_time: startTime,
        conference_end_time: endTime,
        conference_date: selectedDate,
        conference_end_date: selectedEndDate,
        conference_doller_price: addConference.c_conference_doller_price,
        conference_aed_price: addConference.c_conference_aed_price,
        conferenceCategory,
         isChecked,
         isCouponClam,
  
      }
      //   console.clear();
      // console.log(data)
      //   data.title == "" ? setdisabled(false) :
      //       data.descriptions == "" ? setdisabled(false) :
      //           setdisabled(true)
    console.log(data);
  
      axios.get('/sanctum/csrf-cookie').then(response => {
  
        axios.post(`/api/conference-store`, data).then(res => {
  
          if (res.data.status === 200) {
  
  
            swal('Success', res.data.message, 'success');
  
            history.push('/admin/conference/manage');
          }
          else {
  
            setConferenceCategory({ ...conferenceCategory, error_list: res.data.validate_error })
  
          }
  
        });
  
  
      });
  
  
    }


    let backGroundButtonByEvent = "";
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);

    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,
    return (
  
      <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
        <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
          <h4 sx={{ m: 2, color: '#000000' }} >
            <Button sx={{
              float: 'right',
              marginTop: '2%',
              backgroundColor: backGroundButtonByEvent,
              ":hover": {
                color: "white"
              }
            }}
              color='success'
              size='small'
              variant='contained'
              onClick={() => history.goBack()}>
              Back
            </Button>
          </h4>
          <Card sx={{ width: '60vw', float: 'center' }} >
            <CardContent >
              <Typography component="h1" variant="h5">
                Add Conferecnce
              </Typography>
              <Box component="form" onSubmit={submitConference} noValidate sx={{ mt: 3 }}>
                <Grid container spacing={4}>
                  <Grid item xs={6} >
                    <TextField
                      disabled
                      autoComplete="given-name"
                      required
                      fullWidth
                      label="Evnet Name"
                      autoFocus
                      name='event_name' onChange={handleInput}
                      defaultValue={eventName || ""}
                      helperText={addConference.error_list.title} />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Conferecnce Category</InputLabel>
                      <Select
  
                        value={conferenceCategory || ""}
                        onChange={handleConferenceCategory}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Conferecnce Category" >
                        {
                          conferenceCategoryData && conferenceCategoryData.map((val, index) => {
                            return (
                              <MenuItem value={val.id} key={val.id}>{val.conference_category_title} </MenuItem>
                            )
                          })
                        }
  
  
  
                      </Select>
  
                      <FormHelperText></FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      label="Conference Name"
                      autoFocus
                      name='w_workshop_name' onChange={handleInput}
                      helperText={addConference.error_list.w_workshop_name} />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      label="Conference Day"
                      autoFocus
                      name='conference_day' onChange={handleInput}
                      helperText={addConference.error_list.w_workshop_url} />
                  </Grid>
                  {/* <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      label="workshop Date"
                      autoFocus
                      name='w_workshop_url' onChange={handleInput}
                      helperText={addWorkShop.error_list.w_workshop_url} />
                  </Grid> */}
  
  
                  <Grid item xs={6} >
                    <TextField
                      id="date"
                      fullWidth
                      label="Conference Date"
                      type="date"
                      value={selectedDate}
                      onChange={handleDateChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      id="date"
                      fullWidth
                      label="Conference End Date"
                      type="date"
                      value={selectedEndDate}
                      onChange={handleEndDateChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      id="time"
                      label="Conference Start Time"
                      type="time"
                      fullWidth
                      value={startTime}
                      onChange={handleStartTime}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 minutes interval
                      }} />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      id="time"
                      label="Conference End Time"
                      type="time"
                      fullWidth
                      value={endTime}
                      onChange={handleEndTime}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 minutes interval
                      }} />
                  </Grid>
  
                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      type="number"
                      label="Saudi Riyal Price"
                      autoFocus
                      name='w_workshop_amount' onChange={handleInput}
                      helperText={addConference.error_list.w_workshop_amount} />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      type="number"
                      label="Affiltion Price (USD)"
                      autoFocus
                      name='w_workshop_discount_amount' onChange={handleInput}
                      helperText={addConference.error_list.w_workshop_discount_amount} />
                  </Grid>
                   <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      type="number"
                      label="AED Price"
                      autoFocus
                      name='c_conference_aed_price' onChange={handleInput}
                      helperText={addConference.error_list.c_conference_aed_price} />
                  </Grid>
                   <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      type="number"
                      label="Doller Price"
                      autoFocus
                      name='c_conference_doller_price' onChange={handleInput}
                      helperText={addConference.error_list.c_conference_doller_price} />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      type="number"
                      label="No of seats"
                      autoFocus
                      name='w_workshop_seats' onChange={handleInput}
                      helperText={addConference.error_list.w_workshop_seats} />
                  </Grid>
                  <Grid item xs={3} >
                    <FormControlLabel control={<Checkbox color="success" />}
                      label="Coupon"
                      color="success"
                      onChange={handleCheckboxChange} checked={isChecked} />
                    <br></br>
                    <Typography
                      component="span" style={{ color: "#311b92", fontSize: "90%" }}>
                      Coupon is {isChecked ? ' Applied' : ' Not Applied'}.
                    </Typography>
  
                  </Grid>
                   <Grid item xs={3} >
                    <FormControlLabel control={<Checkbox color="success" />}
                      label="Clam Coupon"
                      color="success"
                      onChange={handleCheckboxCouponClam} checked={isCouponClam} />
                    <br></br>
                    <Typography
                      component="span" style={{ color: "#311b92", fontSize: "90%" }}>
                      Coupon Clam is {isCouponClam ? ' Applied' : ' Not Applied'}.
                    </Typography>
  
                  </Grid>
  
  
                  {/* <Grid item xs={12} >
                                    <FormControlLabel required control={<Checkbox color="success" />}
                                        label=" Coupon"
                                        color="success"
                                        onChange={handleCheckboxChange} value="41" checked={isChecked} />
                                    <FormHelperText>Coupon is {isChecked ? ' Applied' : ' Not Applied'}.</FormHelperText>
                                </Grid> */}
  
  
  
  
  
                </Grid>
  
                <Grid container justifyContent="flex-end">
                  <Button
                    disabled={disabled}
                    type="submit"
                    // fullWidth
                    variant="contained"
                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                    Add conference
                  </Button>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </div>
  
    );
  }
  

export default AddConference;
